import React from 'react';

import PropTypes from 'prop-types';

import FacebookLogin from './FacebookLogin/FacebookLogin';
import GoogleLogin from './GoogleLogin/GoogleLogin';

import styles from './SocialButtons.scss';

function SocialButtons(props) {
    const {
        onFacebookClick,
        onGoogleClick,
        capabilities,
    } = props;

    return (
        <div className={styles.socialButtons}>
            <GoogleLogin onClick={onGoogleClick} />
            {capabilities.includes('facebookLogin') && <FacebookLogin
                autoLoad={false}
                onClick={onFacebookClick}
            />}
        </div>
    );
}

SocialButtons.propTypes = {
    capabilities: PropTypes.arrayOf(PropTypes.string),
    onFacebookClick: PropTypes.func.isRequired,
    onGoogleClick: PropTypes.func.isRequired,
};

SocialButtons.defaultProps = {
    capabilities: [],
};

export default SocialButtons;
